<template>
<v-layout row wrap justify-center align-center no-gutters
  class="cont-sec-transacciones pb-8"
  :style="{backgroundImage:'url('+imagenFondo+')'}"
  >
  <!-- <v-overlay :value="!cargoImagen">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay> -->
  <div class="overback"></div>
  <v-flex xs12 sm9 class="ma-0 pt-3 pt-8 px-3 cont-info">
    <v-container fluid class="fluid">
      <v-row class="no-gutters py-10 mt-8">
        <v-col cols="12" class="txt-primary text-right py-3 mt-1 mb-4">
          <h2 class="font-2"> {{itemsec.titulo}} </h2>
          <h3 class="lh-1"> {{itemsec.subtitulo}}</h3>
        </v-col>
        <v-col cols="12" sm="12"  md="5" class="cont-pse">
          <div class="card-pse text-center mx-auto">
            <img src="../assets/img/logo-pse.png" alt="" class="icono-pse">
            <h3>Pagos en línea</h3>
            <v-btn @click="openPage" color="primary" small class="font-weight-bold" >REALIZAR PAGO</v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="7" class="text-right mt-4" >
          <div class="btn-transaccion d-flex justify-start align-center my-1"
          v-for="(tran, idx) in transacciones" :key="'tran-'+idx"
          >
            <h3>{{tran.name}}</h3>
            <v-btn color="primary" class="open-transaccion" rounded small
            @click="actionBtn(tran.url_link, tran.id_cont_cate, tran.name)">ABRIR <v-icon right>mdi-chevron-right</v-icon> </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-flex>
</v-layout>
</template>
<script>
import axios from 'axios'
export default {
  name: 'secTransacciones',
  data () {
    return {
      imgFondo: '../../assets/img/back-sec-transacciones.jpg',
      imagenFondo: '',
      cargoImagen: false,
      itemsec: {
        titulo: 'Transacciones en línea',
        subtitulo: 'Conoce aquí todo lo relacionado con tu factura EAAV'
      },
      transacciones: [
        {
          name: 'Expedición copia de factura',
          url_link: 'expedir'
        },
        {
          name: 'Instructivo para generar factura',
          url_link: 'instructivoFactura'
        },
        {
          name: 'Solicitudes y PQRD',
          url_link: 'pqrd'
        }

      ]
    }
  },
  async created () {
    await axios
      .get('' + this.$store.state.rutaApi + 'imagen_fondo')
      .then(response => (this.imagenFondo = response.data[0].imagenes_api[0]))
    this.cargoImagen = true
    // console.log(this.imagenFondo)
  },
  methods: {
    actionBtn (link, id, name) {
      // console.log(name)
      if (link == 'contenido') {
        this.$router.replace({ name: link, params: { catName: name } }).catch(() => { this.$emit('reload') })
        this.$store.state.idContenido = id
      } else {
        if (link == 'pqrd') {
          window.location.href = 'https://stage.eaav.gov.co/tipo_pqrd'
        }
        if (link == 'expedir') {
          window.location.href = 'https://stage.eaav.gov.co/consulta_factura'
        }
        if (link == 'instructivoFactura') {
          window.open('https://stage.eaav.gov.co/storage/documento-web/May2022/ZtIBWq1NgAw0tLKLbKdD.pdf', '_blank')
          // window.location.href = ''
        } else {
          this.$router.push({ name: link })
        }
      }
    },
    openPage () {
      window.location.href = 'https://stage.eaav.gov.co/consulta_pago'
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/globals.scss';
.cont-sec-transacciones{
  // background:url('');
  background-size: cover;
  background-position: top;
  background-attachment: fixed;
  position: relative;
  box-shadow: 0px -15px 10px -15px #111 inset;
}
.overback{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background: rgb(255,255,255);
  background: url('../assets/img/divider-back.svg'), linear-gradient(270deg, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0) 100%);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center -.1%;
  z-index: 0;
}
.cont-info{
  position: relative;
}
.btn-transaccion{
  padding: 10px;
  background-color:#FFFFFF;
  border-radius: 5px;
  border:solid #2B5AC4  1px;
  h3{
    margin: 0px;
    padding: 0px;
    color: #2B5AC4;
    font-size: 1.2em;
    text-align: left;
    line-height: 1.1em;
  }
  .open-transaccion{
    margin-left: auto;
  }
}
.card-pse{
  background: #FFFFFF;
  padding: 10px;
  border-radius: 10px;
  width: 270px;
  margin-top: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
  .icono-pse{
    margin-top: -40px;
  }
}
</style>
